interface ResizeHandleProps {
  onResizeStart: (e: React.MouseEvent) => void;
}

export function ResizeHandle({ onResizeStart }: ResizeHandleProps) {
  return (
    <div
      role='separator'
      aria-orientation='vertical'
      className='absolute inset-y-0 right-0 z-10 flex w-px cursor-ew-resize items-center justify-center bg-border transition-colors after:absolute after:inset-y-0 after:right-1/2 after:w-1 after:translate-x-1/2 hover:bg-primary'
      onMouseDown={onResizeStart}
    />
  );
}
